import { HttpContextToken } from '@angular/common/http';

// Marks an HTTP request that updates its owner in place, without requiring an
// app-wide overlay. The loader interceptor reads this per-request value,
// avoiding the legacy shared one-shot `LoaderService.disable` flag.
export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);
